export const SDK_NOT_CONFIGURED_ERROR_MESSAGE =
	"The SDK has not been configured. Please call .configure on the base SDK before you call any other methods";
